import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { RouterService } from "../../../services/router/router.service";
import { UserService } from "src/app/services/user/user.service";
import { LanguagesService } from "src/app/services/languagesService/languages.service";
import firebase from "firebase/app";
import { TagsService } from 'src/app/services/tags/tags.service';

@Component({
  selector: 'app-kpi-detail',
  templateUrl: './kpi-detail.page.html',
  styleUrls: ['./kpi-detail.page.scss'],
})
export class KpiDetailPage implements OnInit {
  db: any;
  graph: any;
  userName: string;
  constructor(private route: ActivatedRoute,
    private routerService: RouterService,
    private userService: UserService,
    public languageService: LanguagesService,
    private tagsService:TagsService,) {
    this.db = firebase;
    this.graph = this.route.snapshot.paramMap.get("id");
    this.getUserNameGNX();
  }

  async getUserNameGNX() {
    this.userService.getUserInfo().subscribe((info: any) => {
      if (info && info.gnxCredential1) {
        this.userName = info.gnxCredential1;
      }
    });
  }

  ngOnInit() {
    this.tagsService.setEventTag('indicators_page','indicators_detail_clicked');
  }

  get getTextsIUPageKpiDetail() {
    //console.log(this.languageService.textsIU.page_home);
    return this.languageService.textsIU.page_kpi_detail;
  }
  
  get getTextsIUPageKpi() {
    //console.log(this.languageService.textsIU.page_home);
    return this.languageService.textsIU.page_kpi;
  }

}
